import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

import {
  store
} from '@/store/store';

const routes = [
  {
    path: "/",
    name: "main",
    component: () => import("./components/main"),
    meta: { esPublico: true },
  },
  {
    path: "/instalaciones",
    name: "instalaciones",
    component: () => import("./components/instalaciones"),
    meta: { esPublico: true, bread:[{label: 'messages.facilities', to: '/instalaciones'}] },
  },  
  {
    path: "/login",
    name: "login",
    component: () => import("./components/login"),
    meta: { esPublico: true, soloCuandoNoEsteLogueado: true },
  },
  /* {
    path: "/especialistas",
    name: "especialistas",
    component: () => import("./components/especialistas"),
    meta: { esPublico: true, bread:[{label: 'messages.specialistList', to: '/listado-especialistas'},{label: 'Buscador Especialistas', to: '/especialistas'}]  },
  }, */
  {
    path: "/registrate",
    name: "registrate",
    component: () => import("./components/registro"),
    meta: { esPublico: true, bread:[{label: 'messages.contactUs', to: '/registrate'}] },
  },
  {
    path: "/nosotros",
    name: "nosotros",
    component: () => import("./components/quienes_somos"),
    meta: { esPublico: true, bread:[{label: 'messages.aboutUs', to: '/nosotros'}] },
  },
  {
    path: "/cotizacion",
    name: "cotizacion",
    component: () => import("./components/cotizacion"),    
    meta: { tipoUsuario: ['user','admin',"superadmin"], bread:[{label: 'messages.quotations', to: '/cotizacion'}] },
  },  
  {
    path: "/usuarios_admin",
    name: "usuarios_admin",
    component: () => import("./components/usuarios_admin"),
    meta: { tipoUsuario: ['admin',"superadmin"], bread:[{label: 'Usuarios Admin', to: '/usuarios_admin'}]  },
  },
  {
    path: "/especialidades_admin",
    name: "especialidades_admin",
    component: () => import("./components/especialidades_admin"),
    meta: { tipoUsuario: ['admin',"superadmin"], bread:[{label: 'Especialidades Admin', to: '/especialidades_admin'}] },
  },
  {
    path: "/cirugias_admin",
    name: "cirugias_admin",
    component: () => import("./components/cirugias_admin"),
    meta: { tipoUsuario: ['admin',"superadmin"], bread:[{label: 'Cirugías Admin', to: '/cirugias_admin'}]  },
  },
  {
    path: "/tarifas_admin",
    name: "tarifas_admin",
    component: () => import("./components/tarifas_admin"),
    meta: { tipoUsuario: ["superadmin"], bread:[{label: 'Tarifas Admin', to: '/tarifas_admin'}]  },
  },
  {
    path: "/usuario-especialidades",
    name: "usuario-especialidades",
    component: () => import("./components/usuarios_especialidades_admin"),
    meta: { tipoUsuario: ['admin',"superadmin"], bread:[{label: 'Volver', to: '/usuarios_admin'}]  },
  },  
  {
    path: "/informacion",
    name: "informacion",
    component: () => import("./components/informacion"),
    meta: { tipoUsuario: ['user','admin',"superadmin"], bread:[{label: 'messages.information', to: '/informacion'}] },
  },  
  {
    path: "/change-password",
    name: "change-password",
    component: () => import("./components/cambio_password"),
    meta: { tipoUsuario: ['user','admin',"superadmin"] },
  },    
  {
    path: "/mis_articulos/revisar_articulo/:id",
    name: "revisar_articulo",
    component: () => import("./components/articulos_create"),
    meta: { tipoUsuario: ['admin',"superadmin"], bread:[{label: 'Volver', to: '/articulos_admin'}] },
  },
  {
    path: "/articulos_admin",
    name: "articulos_admin",
    component: () => import("./components/articulos_admin"),
    meta: { tipoUsuario: ['admin',"superadmin"], bread:[{label: 'Articulos Admin', to: '/articulos_admin'}] },
  },  
  {
    path: "/aseguradoras",
    name: "aseguradoras",
    component: () => import("./components/aseguradoras_admin"),
    meta: { tipoUsuario: ['admin',"superadmin"], bread:[{label: 'Aseguradoras Admin', to: '/aseguradoras'}] },
  },
  {
    path: "/cotizaciones_admin",
    name: "cotizaciones_admin",
    component: () => import("./components/cotizaciones_admin"),
    meta: { tipoUsuario: ['admin',"superadmin"], bread:[{label: 'Cotizaciones Admin', to: '/cotizaciones_admin'}] },
  },
  {
    path: "/polizas",
    name: "polizas",
    component: () => import("./components/polizas_admin"),
    meta: { tipoUsuario: ['admin',"superadmin"], bread:[{label: 'Pólizas Admin', to: '/polizas'}] },
  },     
  {
    path: "/documentos",
    name: "documentos",
    component: () => import("./components/informacion_admin"),
    meta: { tipoUsuario: ['admin',"superadmin"], bread:[{label: 'Documentos Admin', to: '/documentos'}] },
  },    
  {
    path: "/blog",
    name: "blog",
    component: () => import("./components/blog"),
    meta: { esPublico: true, bread:[{label: 'messages.blog', to: '/blog'}] },
  },
  {
    path: "/blog/detalle_articulo/:id",
    name: "detalle_articulo",
    component: () => import("./components/detalle_articulo"),
    meta: { esPublico: true, bread:[{label: 'messages.back', to: '/blog'}] },
  },  
  {
    path: "/services-main",
    name: "services_main",
    component: () => import("./components/services_views/services"),
    meta: { esPublico: true, bread:[{label: 'messages.ourServices', to: '/services-main'}] },    
  },  
  {
    path: "/servicios-cirugias",
    name: "servicios",
    component: () => import("./components/services_views/servicios_cirugias"),
    meta: { esPublico: true, bread:[{label: 'messages.surgeryServices', to: '/servicios-cirugias'}] },
  },
  {
    path: "/bienestar-cirujanos",
    name: "bienestar_cirujanos",
    component: () => import("./components/services_views/bienestar_cirujanos"),
    meta: { esPublico: true, bread:[{label: 'messages.surgeonWellness', to: '/bienestar-cirujanos'}] },    
  }, 
  {
    path: "/bienestar-pacientes",
    name: "bienestar_pacientes",
    component: () => import("./components/services_views/bienestar_pacientes"),
    meta: { esPublico: true, bread:[{label: 'messgaes.patientWellness', to: '/bienestar-pacientes'}] },    
  },  
  {
    path: "/listado-especialistas",
    name: "listado_especialistas",
    component: () => import("./components/listado_especialistas"),
    meta: { esPublico: true, bread:[{label: 'messages.specialistList', to: '/listado-especialistas'}] },    
  },
  {
    path: "/mis_articulos",
    name: "mis_articulos",
    component: () => import("./components/mis_articulos"),
    meta: { tipoUsuario: ['admin',"superadmin"], bread:[{label: 'Blog', to: '/blog'},{label: 'Mis Artículos', to: '/mis_articulos'}]  },
  },
  {
    path: "/mis_articulos/crear_articulos",
    name: "crear_articulos",
    component: () => import("./components/articulos_create"),
    meta: { tipoUsuario: ['admin',"superadmin"], bread:[{label: 'Blog', to: '/blog'},{label: 'Volver', to: '/mis_articulos'}] },
  },  
  {
    path: "/mis_articulos/editar_articulos/:id",
    name: "editar_articulos",
    component: () => import("./components/articulos_create"),
    meta: { tipoUsuario: ['admin',"superadmin"], bread:[{label: 'Blog', to: '/blog'},{label: 'Volver', to: '/mis_articulos'}] },
  },  
  {
    path: "/ppdp",
    name: "ppdp",
    component: () => import("./components/politica_proteccion_datos_personales"),
    meta: { esPublico: true, bread:[{label: 'messages.policeProtectionPersonalData', to: '/ppdp'}] },
  },
  {
    path: "/pipma",
    name: "pipma",
    component: () => import("./components/pipma"),
    meta: { esPublico: true, bread:[{label: 'Política Institucional Para Médicos Adscritos', to: '/pipma'}] },
  },
  /* no mostradas */ 
  /* {
    path: "/reserva",
    name: "reserva",
    component: () => import("./components/reservas"),
    meta: { tipoUsuario: ['XXX'] },
  },
  {
    path: "/reservas_admin",
    name: "reservas",
    component: () => import("./components/reservas_admin"),
    meta: { tipoUsuario: ['XXX'] },
  },
  {
    path: "/mis_reserva",
    name: "mis_reservas",
    component: () => import("./components/mis_reservas"),
    meta: { tipoUsuario: ['XXX'] },
  },       */ 
  /* hasta aqui los no mostrados */
  /* {
    path: "/test",
    name: "test",
    component: () => import("./components/test_cotizacion"),    
    meta: { tipoUsuario: ['user','admin',"superadmin"] },
    //meta: { esPublico: true },    
  },   */
  {
    path: "*",
    redirect: { name: 'main' }      
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  const esPublico = to.matched.some((record) => record.meta.esPublico);  
  const soloCuandoNoEsteLogueado = to.matched.some(
    (record) => record.meta.soloCuandoNoEsteLogueado
  );  
  const dataUser = store.getters.getUserData //se verifica si esta logueado

  const token=dataUser.token
  const tipoUsuarioLogueado=dataUser.tipo_usuario  
  const debeCambiarPassword=dataUser.cambiar_password==1?true:false

  //no es publico y no esta logueado  
  if (!esPublico && !token) {    
    return next({ name:'login' });    
  }
  //esta logueado y solo se accede cuando no este logueado
  if (token && soloCuandoNoEsteLogueado) {        
    return next({ name:'main' });    
  }
  //verificar si existe alguna restriccion de tipo de usuario  
  const tiposAcceso = to.matched[0].meta.tipoUsuario?to.matched[0].meta.tipoUsuario:[];
  
  if (tiposAcceso.length>0 && tipoUsuarioLogueado!=null) {    
    if(tiposAcceso.indexOf(tipoUsuarioLogueado)==-1){
      return next({ name:'main' });  
    }  
  }  
  if(debeCambiarPassword && to.name!="change-password"){
    return next({ name:'change-password' });
  }
  next()
});

export default router;
